export const rustWebAppContactFormId = 'contact-form-rwad';
